import { initializeApp } from "firebase/app";

const firebaseDefaults = {
  apiKey: "AIzaSyDPluWO4afB4XV71uiXNMeUL5KJi94sQIA",
  authDomain: "reflection-futball.firebaseapp.com",
  projectId: "reflection-futball",
  storageBucket: "reflection-futball.firebasestorage.app",
  messagingSenderId: "259059255400",
  appId: "1:259059255400:web:926c677e55a32a51a393dd",
};

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || firebaseDefaults.apiKey,
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || firebaseDefaults.authDomain,
  projectId:
    import.meta.env.VITE_FIREBASE_PROJECT_ID || firebaseDefaults.projectId,
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || firebaseDefaults.storageBucket,
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ||
    firebaseDefaults.messagingSenderId,
  appId: import.meta.env.VITE_FIREBASE_APP_ID || firebaseDefaults.appId,
};

const missingFirebaseConfig = Object.entries(firebaseConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingFirebaseConfig.length > 0) {
  throw new Error(
    `Missing Firebase environment variables: ${missingFirebaseConfig.join(", ")}`,
  );
}

if (typeof window !== "undefined" && missingFirebaseConfig.length === 0) {
  const missingRuntimeEnv = Object.entries({
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  })
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missingRuntimeEnv.length > 0) {
    console.warn(
      `Using fallback Firebase config because build-time env vars are missing: ${missingRuntimeEnv.join(", ")}`,
    );
  }
}

const app = initializeApp(firebaseConfig);

export default app;
